import { render, staticRenderFns } from "./DragAndDropNotice.vue?vue&type=template&id=6efab70c&scoped=true"
import script from "./DragAndDropNotice.vue?vue&type=script&lang=ts"
export * from "./DragAndDropNotice.vue?vue&type=script&lang=ts"
import style0 from "./DragAndDropNotice.vue?vue&type=style&index=0&id=6efab70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efab70c",
  null
  
)

export default component.exports